//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.Electrical.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AdditionalLength",1,0],[1,"DistanceForSplicePoint",0,"Expression",0],[0,"PointOnPath",1,"Point",0],[0,"SpliceName",1,0],[0,"SwitchRouteNode",1,0]],[[["startRouteNode","endRouteNode"],"SetEndRouteNodesOfRouteSection",{},2,0],[["distanceForSplicePoint"],"SetDistanceFromAnchorNode",{},1,0],[["totalLengthOfRouteSection"],"SetTotalCurveLengthOfRouteSection",{},1,0]],[]];
SPLM.Routing.Electrical.SplicePositionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.Electrical.SplicePositionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;